(function() { window.GUID_135e89b2_58e5_41e7_96f9_fb4225d84143 = { getGuid: function() { return "135e89b2-58e5-41e7-96f9-fb4225d84143"; } }; })();
var CS;
(function (CS) {
    class Debug {
        static Log(...data) {
            if (CS.CommonData.Current.IsDebug()) {
                console.log(data);
            }
        }
    }
    CS.Debug = Debug;
})(CS || (CS = {}));
(function (CS) {
    var Debug;
    (function (Debug) {
        class GroupedLog {
            get GroupName() {
                return this.groupName;
            }
            get GroupId() {
                return this.groupId;
            }
            constructor(groupId, groupName, persistent, includeUrl) {
                this.groupId = groupId;
                this.groupName = groupName;
                this.persistent = persistent;
                this.includeUrl = includeUrl;
                this.enabled = CS.CommonData.Current && CS.CommonData.Current.IsDebug();
                this.functions = new Array();
            }
            static Get(groupId, groupName, persistent, includeUrl) {
                if (persistent) {
                    let obj = window[groupId];
                    if (obj != null && CS.Types.Is(obj, GroupedLog))
                        return obj;
                    obj = new GroupedLog(groupId, groupName, persistent, includeUrl);
                    window[groupId] = obj;
                    return obj;
                }
                return new GroupedLog(groupId, groupName, persistent, includeUrl);
            }
            Info(text) {
                this.Log(() => { console.info(text); }, 0);
            }
            Log(consoleLogAction, printAfterDelay) {
                if (!this.enabled) {
                    return;
                }
                //this is to get the caller and line of the code
                function getErrorObject() {
                    try {
                        throw Error('');
                    }
                    catch (err) {
                        return err;
                    }
                }
                var err = getErrorObject();
                //var caller_line = err.stack.split("\n")[4];
                //var index = caller_line.indexOf("at ");
                //var clean = Number(caller_line.slice(index + 2, caller_line.length));
                this.functions.push([consoleLogAction, err]);
                CS.Lag(`GroupedLog-${this.groupId}`, printAfterDelay, () => {
                    const label = this.groupName + (this.includeUrl ? ` [${location.pathname}]` : "");
                    console.groupCollapsed(label);
                    for (var i = 0; i < this.functions.length; i++) {
                        var d = this.functions[i];
                        d[0]();
                        let stack = "Stack Trace";
                        console.groupCollapsed(stack);
                        console.log(d[1].stack);
                        console.groupEnd();
                    }
                    console.groupEnd(label);
                    if (!this.persistent)
                        this.functions = new Array();
                });
            }
        }
        Debug.GroupedLog = GroupedLog;
    })(Debug = CS.Debug || (CS.Debug = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-debug.js.map
